<template>
    <fragment>
        <CityMapIndex/>
        <CityMapAdmin/>
        <CityMapSettings/>
        <CityMapWooCommerce/>
        <TxProductStats/>
    </fragment>
</template>

<script>
    import CityMapWooCommerce from "./__partials__/CityMapWooCommerce";
    import CityMapSettings from "./__partials__/CityMapSettings";
    import CityMapIndex from "./__partials__/CityMapIndex";
    import CityMapAdmin from "./__partials__/CityMapAdmin";

    let layout = lovemap.vue_env;

    export default {
        name: "index",
        layout: layout,
        components: {
            CityMapAdmin,
            CityMapIndex,
            CityMapSettings,
            CityMapWooCommerce
        }
    }
</script>

<style scoped>

</style>